import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { EnterpriseService } from 'src/app/services/enterprise/enterprise.service';
import { StreamingServerService } from 'src/app/services/streamingServer/streamingServer.service';
import { MessageModalComponent } from 'src/app/shared/components/modals/message/message-modal.component';
import { ServerStreamingModalComponent } from 'src/app/shared/components/modals/server-streaming/server-streaming-modal.component';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { AlertService, MessageSeverity } from 'src/app/shared/services/alert.service';

@Component({
  selector: 'app-server-streaming',
  templateUrl: './server-streaming.component.html',
  styleUrls: ['./server-streaming.component.css']
})
export class ServerStreamingComponent implements OnInit {
  loading: boolean = false;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = ['name','ip','streamingRtmp','streamingFile','action'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  enterprises = [];
  enterpriseSelect = 0;
  color1: string;
  color2: string;
  colorFont: string;
  colorFont2: string;
  enabledRead: number;
  enabledWrite: number;

  constructor(
    public dialog: MatDialog,
    private alertService: AlertService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private streamingServerService: StreamingServerService,
    private enterpriseService: EnterpriseService,
    ) {
      document.getElementById("titleHeaderNav").innerHTML = 'Streaming > <span class="font-weight-bold">Servidores</span>';
    }

  ngOnInit() {
    this.setTheme();
    this.dataSource.paginator = this.paginator;
    this.paginator._intl.itemsPerPageLabel = '';
    this.enterpriseSelect = (+localStorage.getItem(AppConstants.Session.ENTERPRISE));
    this.getList();
  }

  setTheme(){
    this.color1 = localStorage.getItem(AppConstants.Session.THEME_COLOR1);
    this.color2 = localStorage.getItem(AppConstants.Session.THEME_COLOR2);
    this.colorFont = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT);
    this.colorFont2 = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT2);
    //validate Permisses menu
    var menu = JSON.parse(localStorage.getItem(AppConstants.Session.MENU));
    var page = this.router.url.split("/");
    var i = page[page.length-1];
    var itemTag = menu.filter(x => x.tag != null && (x.tag.toString()).toLowerCase().includes(i));
    if(itemTag.length>0){
      this.enabledRead = itemTag[0].activeRead;
      this.enabledWrite = itemTag[0].activeWrite;
    }else{
      this.enabledRead = 0;
      this.enabledWrite = 0;
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getEnterprises() {
    this.spinner.show();
    this.enterpriseService.getEnterprises().subscribe((response) => {
        this.enterprises = response.filter(f => f.enabled == AppConstants.Flag.Active);
        this.enterpriseSelect = parseInt(localStorage.getItem(AppConstants.Session.ENTERPRISE));
        this.getList();
    },
    (error: HttpErrorResponse) => {
        this.spinner.hide();
    });
  }

  getList(){
    this.spinner.show();
    this.streamingServerService.getList(this.enterpriseSelect).subscribe((_) => {
      if(_.error == null){
        this.dataSource.data = _.data;
      }
      this.spinner.hide();
    });
  }

  openAddModal() {
    let dialogRef = this.dialog.open(ServerStreamingModalComponent, {
      data: { title: AppConstants.TitleModal.CREATE_SERVER_STREAMING, enabledWrite: this.enabledWrite,
        enabledRead: this.enabledRead, action: 0,idEnterprise: this.enterpriseSelect, obj:null,
        color: this.color1,colorFont:this.color2},
      width: '500px',
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(_ => {
      this.getList();
    });
  }

  openEditModal(data){
      let dialogRef = this.dialog.open(ServerStreamingModalComponent, {
        data: { title: AppConstants.TitleModal.UPDATE_SERVER_STREAMING, enabledWrite: this.enabledWrite,
          enabledRead: this.enabledRead,action: 1,idEnterprise: this.enterpriseSelect,obj:data,
        color: this.color1,colorFont:this.color2},
        width: '500px',
        hasBackdrop: true
      });
      dialogRef.afterClosed().subscribe(_ => {
        this.getList();
      });
  }

  changeEnterprise(data) {
    this.enterpriseSelect = data.value;
    this.getList();
  }

  delete(obj) {
    let dialogRef = this.dialog.open(MessageModalComponent, {
      data: {
        title: AppConstants.TitleModal.DELETE_CONFIRMATION_TITLE,
        message: `${AppConstants.MessageModal.DELETE_SERVER_CONFIRMATION_MESSAGE1}`,
        hasButton: true,
        contentButton: {
          yes: 'SI',
          no: 'CANCELAR'
        }
      },
      width: '600px',
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response.result == true) {
        this.deleteSecurity(obj.id);
      }
    });

  }

    deleteSecurity(id: number) {
      this.spinner.show();
      this.streamingServerService.delete(id).subscribe((response => {
        this.spinner.hide();
        this.alertService.showMessage(AppConstants.TitleModal.DELETE_STREAMING_SERVER, AppConstants.MessageModal.DELETE, MessageSeverity.success);
        this.getList();
      }),
      (error: HttpErrorResponse) => {
        this.alertService.showMessage(AppConstants.TitleModal.DELETE_STREAMING_SERVER, error.error.messages, MessageSeverity.error);
        this.spinner.hide();
      });
    }
}
